import React from 'react';
import Container from 'common/components/UI/Container';
import customers from './customers.data';
import {
  Wrapper,
  Heading,
  Rows,
  Row,
  Track,
  List,
  Item,
} from './customerlogos.style';

const BASE_HEIGHT = 30;

const renderItem = (company, hidden) => (
  <Item key={company.name} style={{ '--s': company.scale }}>
    {company.src ? (
      <>
        <img
          src={company.src}
          alt={hidden ? '' : company.name}
          width={Math.round(BASE_HEIGHT * company.scale * company.ratio)}
          height={Math.round(BASE_HEIGHT * company.scale)}
          loading="lazy"
          decoding="async"
          data-plain={company.plain ? '' : undefined}
        />
        {company.label && <small>{company.label}</small>}
      </>
    ) : (
      <span>{company.name}</span>
    )}
  </Item>
);

// onHero: the band stands inside the hero (Banner), under the band of audit
// figures, so the marks are drawn white on its blue.
const CustomerLogosSection = ({ onHero }) => {
  const rows = [1, 2].map((row) => customers.filter((c) => c.row === row));

  return (
    <Wrapper id="customers" aria-labelledby="customers-heading" $onHero={onHero}>
      <Container>
        <Heading id="customers-heading">
          Engineers at these companies have used CloudPouch
        </Heading>
      </Container>
      <Rows>
        {rows.map((list, i) => (
          <Row key={i}>
            <Track $reverse={i === 1}>
              <List>{list.map((c) => renderItem(c, false))}</List>
              <List aria-hidden="true">{list.map((c) => renderItem(c, true))}</List>
            </Track>
          </Row>
        ))}
      </Rows>
    </Wrapper>
  );
};

export default CustomerLogosSection;
